import {Capability} from "../formElementCapability";
import {baseRestrictions, restrictionSchema, formElementsSchema} from "./addressValidationSchema";
import IFormElementSchema from "./iFormElementSchema";
import TemplateElement from "./templateElement";

export default class AddressValidation extends TemplateElement {
  include_zip_plus_four: boolean;
  _elementRestrictions: Array<Array<Capability>> = [baseRestrictions];
  restrictionSchema: object = restrictionSchema;
  formElementsSchema: Array<IFormElementSchema> = formElementsSchema;

  get controlName(): string {
    return "USPS Address Validation";
  }

  get controlIcon(): string {
    return 'icon puzzle-piece';
  }
}
